export const readFileContent = (file: File): Promise<string | null> => new Promise((resolve, reject) => {
  const { FileReader } = window;
  const fileReader = new FileReader();

  fileReader.onerror = (e) => {
    console.error('[QA] Error reading file:', e.toString());
    resolve(null);
  };

  fileReader.onload = (e) => {
    const {
      target: { result },
    } = e;

    if (typeof result === 'string') {
      resolve(result);
    } else {
      console.error('[QA] File result was not type string: ', typeof result);
      resolve(null);
    }
  };

  fileReader.readAsText(file);
});
